/* eslint-disable no-underscore-dangle */

// FIXME: A playlist item shouldn't be conflated with autoadvance logic.
import { setup } from './autoAdvance';

/**
 * Remove all remote text tracks from a player.
 *
 * @param {Object} player - The player to clear tracks on.
 */
export const clearTracks = player => {
  const tracks = player.remoteTextTracks();

  // eslint-disable-next-line
  let i = (tracks && tracks.length) || 0;

  // This uses a `while` loop rather than `forEach` because the
  // `TextTrackList` object is a live DOM list (not an array).
  while (i--) {
    player.removeRemoteTextTrack(tracks[i]);
  }
};

/**
 * Play an item on a player's playlist.
 *
 * @param {Object} player - The player to play the item on.
 * @param {Object} item - A source from the playlist.
 *
 * @return {Player} The player that is now playing the item.
 */
export default (player, item) => {
  const replay = !player.paused() || player.ended();

  player.trigger('beforeplaylistitem', item);

  if (item.customPosterSetter) {
    item.customPosterSetter(player, item);
  } else {
    player.poster(item.poster || '');
  }

  if (item.customSrcSetter) {
    item.customSrcSetter(player, item);
  } else {
    player.src(item.sources);
  }

  // make sure to set the dock elements correctly for each item
  player.dock({
    title: item.title || '',
    description: item.description || '',
  });

  clearTracks(player);

  player.ready(() => {
    (item.textTracks || []).forEach(player.addRemoteTextTrack.bind(player));
    player.trigger('playlistitem', item);

    if (replay) {
      player.play();
    }

    setup(player, player.playlist.autoadvance_.delay);
  });

  return player;
};



// WEBPACK FOOTER //
// ./node_modules/video-js-core/src/playlists/playItem.js